import { render, staticRenderFns } from "./class-discussion-private.vue?vue&type=template&id=39902dc0"
import script from "./class-discussion-private.vue?vue&type=script&lang=js"
export * from "./class-discussion-private.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports